import { matchesSearchQuery } from '@/utils/transliterate'
import type { Building } from '@/types/building'

export const sanitizeBuildingObjectCodeInput = (value: string | number | undefined) =>
  String(value || '')
    .replace(/\D/g, '')
    .slice(0, 5)

export const isValidBuildingObjectCode = (value: string | number | undefined) =>
  /^\d{5}$/.test(sanitizeBuildingObjectCodeInput(value))

export const getBuildingObjectCode = (building: Building | null | undefined) => {
  if (!building) return ''
  const rawCode =
    building.display_code ??
    building.displayCode ??
    building.object_code ??
    building.objectCode ??
    building.building_code ??
    building.buildingCode ??
    building.code
  return sanitizeBuildingObjectCodeInput(rawCode)
}

export const getBuildingIdentity = (building?: Building | null) => {
  if (!building) return ''
  const objectCode = getBuildingObjectCode(building)
  if (isValidBuildingObjectCode(objectCode)) {
    return objectCode
  }
  return building.id != null ? `#${building.id}` : ''
}

export const formatBuildingOptionLabel = (building?: Building | null) => {
  if (!building) return ''
  const idPart = getBuildingIdentity(building)
  const namePart = String(building.name || '').trim()
  return [idPart, namePart].filter(Boolean).join(' • ')
}

export const formatBuildingOptionMeta = (building: Building | null | undefined) => {
  if (!building) return ''
  return String(building.address || '').trim()
}

export const filterBuildingsBySearch = (
  buildings: Building[] | null | undefined,
  inputValue: string
) => {
  const list = Array.isArray(buildings) ? buildings : []
  const query = String(inputValue || '').trim()
  if (!query) return list

  return list.filter((building) => {
    const label = formatBuildingOptionLabel(building)
    const meta = formatBuildingOptionMeta(building)
    const name = String(building?.name || '')
    return (
      matchesSearchQuery(label, query) ||
      matchesSearchQuery(meta, query) ||
      matchesSearchQuery(name, query)
    )
  })
}
